import { Typography } from '@mui/material';
import PublicToolLayout from '../../components/public-tools/PublicToolLayout';
import ToolWidget from '../../components/public-tools/ToolWidget';

export default function WebsiteHealthCheckPage() {
  return (
    <PublicToolLayout title="Website Health Check">
      <Typography variant="h4" fontWeight={800} gutterBottom>
        Website Health Check
      </Typography>
      <Typography variant="body1" sx={{ mb: 3, maxWidth: 780, opacity: 0.92 }}>
        Check your website for technical SEO, crawlability, security, infrastructure,
        discoverability, structured data, and social sharing signals in one scan.
      </Typography>
      <ToolWidget
        scanType="SITE"
        formLabel="Website URL"
        formPlaceholder="https://example.com"
      />
    </PublicToolLayout>
  );
}
